import api from "@/plugins/api";
import { searchOrganisations, getOrganisationAddresses, } from "@/modules/organisation/infrastructure/adapters/organisationService";
/**
 * Sets the global primary address for a contact (direct or linked)
 * via `PUT /contacts/{contactId}/addresses/primary`.
 */
export async function setContactPrimaryAddress(contactId, payload) {
    await api.put(`/contacts/${contactId}/addresses/primary`, payload, { unwrapEnvelope: true });
}
/**
 * Free-text organisation search for the add-address modal's professional picker.
 *
 * Delegates to the organisation service's `searchOrganisations`, which routes a
 * free-text term to `GET /organisations?search=` — NOT the saved-filter
 * `POST /portal/organisations/search` (that endpoint drops the typed term).
 */
export async function searchOrganisationsForPicker(query) {
    const { result } = await searchOrganisations({ search: query, page: 1, pageSize: 5 });
    return result.map((o) => ({ id: o.id, name: o.mainInformation.legalName }));
}
/**
 * Returns the organisation's primary address (US-08, Path B1 — inherit), or `null`
 * when the organisation has no primary address set (Save must then be disabled).
 */
export async function getOrganisationPrimaryAddress(organisationId) {
    const { result } = await getOrganisationAddresses(organisationId, { page: 1, pageSize: 100 });
    return result.find((a) => a.isPrimary) ?? null;
}
/**
 * Updates an existing personal address of a contact via
 * `PUT /contacts/{contactId}/addresses/{addressId}` (US-17.1).
 */
export async function updateContactAddress(contactId, addressId, payload) {
    await api.put(`/contacts/${contactId}/addresses/${addressId}`, payload, { unwrapEnvelope: true });
}
/**
 * Links a contact to an organisation's address via
 * `POST /contacts/{contactId}/org-address-links` (US-08, Path B1 — inherit).
 */
export async function createContactOrgAddressLink(contactId, payload) {
    await api.post(`/contacts/${contactId}/org-address-links`, payload, { unwrapEnvelope: true });
}
/**
 * Deletes an owned (Direct) address from a contact via
 * `DELETE /contacts/{contactId}/addresses/{addressId}` (US-18.1 — OP-5693).
 */
export async function deleteContactAddress(contactId, addressId) {
    await api.delete(`/contacts/${contactId}/addresses/${addressId}`, { unwrapEnvelope: true });
}
/**
 * Removes a contact-organisation-address link (Linked/inherited address) via
 * `DELETE /contacts/{contactId}/org-address-links/{linkId}` (US-18.1 — OP-5693).
 * Only the link is removed — the organisation's address is untouched.
 */
export async function deleteContactOrgAddressLink(contactId, linkId, organisationId, addressId) {
    await api.delete(`/contacts/${contactId}/org-address-links/${linkId}`, {
        unwrapEnvelope: true,
        params: { organisationId, addressId },
    });
}
